export const FETCH_ROLES = "FETCH_ROLES";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";
export const CREATE_ROLES = "CREATE_ROLES";
export const CREATE_ROLES_FAILURE = "CREATE_ROLES_FAILURE";
export const CREATE_ROLES_SUCCESS = "CREATE_ROLES_SUCCESS";
